export const getColor = (index: number) => {
  const colors = [
    '#6ACFD5',
    '#F59B8D',
    '#AE9DD4',
    '#F1BE68',
    '#99CEAC',
    '#D19CCB',
    '#80A9CB',
    '#DAA980',
    '#9BE7B6',
    '#F5CBF1',
    '#90C8F7',
    '#F4CBA9',
    '#CDF4DB',
    '#F0DDEE',
    '#C1DFF8',
    '#F3E1D2',
  ];
  if (index < colors.length) {
    return colors[index];
  } else {
    return (
      '#' +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, '0')
    );
  }
};

export const getColorRgba = (index: number, opacity: number) => {
  const color = getColor(index);
  const rgb = color.replace('#', '');
  const r = parseInt(rgb.substring(0, 2), 16);
  const g = parseInt(rgb.substring(2, 4), 16);
  const b = parseInt(rgb.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const transformColorRgba = (color: string, opacity: number) => {
  const rgb = color.replace('#', '');
  const r = parseInt(rgb.substring(0, 2), 16);
  const g = parseInt(rgb.substring(2, 4), 16);
  const b = parseInt(rgb.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};
